export default "__VITE_ASSET__CQa6DbL___"